import { ExportSocialProvider } from '@/modules/statistics/social/hooks/use-export'
import { SocialMediaType } from '@/modules/statistics/social/types.ts'
import { SocialView } from '@/modules/statistics/social/views/SocialView.tsx'

export const StatisticsTikTokView = () => {
  return (
    <ExportSocialProvider>
      <SocialView socialMediaType={SocialMediaType.TikTok} />
    </ExportSocialProvider>
  )
}
